import Image from "next/image";
import { MediaProp } from "types";
import { getStrapiMedia } from "utils";

interface BannerProps {
  priority?: boolean;
  data: {
    Title: string;
    Subtitle: string;
    Image: MediaProp;
  };
}

const Banner: React.FC<BannerProps> = ({ data, priority = false }) => {
  return (
    <div className="banner">
      <Image
        alt={data.Image.data.attributes.alternativeText || ""}
        src={getStrapiMedia(data.Image)}
        priority={priority}
        fill
        sizes="100vw"
        style={{ objectFit: "cover" }}
      />
      <div className="banner__text">
        <div className="container">
          <div className="banner__text-inner">
            {data.Subtitle?.trim() && <h6>{data.Subtitle}</h6>}
            {data.Title?.trim() && <h1 className="h4">{data.Title}</h1>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
